import { all } from "redux-saga/effects";
import rootBankSaga from "./bank/rootBankSaga";
import rootFinaceSaga from "./finance/rootFinaceSaga";
import rootSubsSaga from "./subscriber/rootSubsSaga";
export default function* rootSaga() {
  yield all([rootBankSaga(), rootSubsSaga(), rootFinaceSaga()]);
}